import React from 'react';

const InstantRakeback = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M1.99707 11.9943C1.99707 17.5145 6.47211 21.9896 11.9924 21.9896C17.5126 21.9896 21.9876 17.5145 21.9876 11.9943C21.9876 6.47406 17.5126 1.99902 11.9924 1.99902C8.65576 1.99902 5.70101 3.63391 3.88548 6.14632",
      stroke: "white",
      strokeWidth: "1.49929",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.25098 1.49866L3.77337 6.46892L8.74364 5.94653",
      stroke: "white",
      strokeWidth: "1.49929",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.5044 9.99502C10.5044 10.8231 9.83319 11.4943 9.00515 11.4943C8.17712 11.4943 7.50586 10.8231 7.50586 9.99502C7.50586 9.16698 8.17712 8.49573 9.00515 8.49573C9.83319 8.49573 10.5044 9.16698 10.5044 9.99502ZM16.4998 13.9929C16.4998 14.8209 15.8285 15.4922 15.0005 15.4922C14.1724 15.4922 13.5012 14.8209 13.5012 13.9929C13.5012 13.1648 14.1724 12.4936 15.0005 12.4936C15.8285 12.4936 16.4998 13.1648 16.4998 13.9929ZM15.5621 8.49625H13.688L8.44036 15.4931H10.3145L15.5621 8.49625Z",
      fill: "white"
    }
  )
);

export { InstantRakeback };
//# sourceMappingURL=InstantRakeback.js.map
